// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"46c4b0c4","96":"70d6741b","162":"654435f0","193":"8236a8e7","251":"72a87a93","256":"0a03e033","267":"c4b3cf1c","340":"1ff01fb7","419":"c6506930","440":"a81d483a","524":"0380adc7","614":"e2c9118a","851":"f180cf7a"}[chunkId] + ".chunk.js";
};